import MyPageCheckbox from './MyPageCheckbox';
export default MyPageCheckbox;
